const ApiConstant: any = {
  getProvisionDeviceSummary: "/ProvisionDevice/GetProvisionDeviceSummary",
  getProvisionSites: "/ProvisionDevice/GetProvisionSites",
  getProvisionPump: "/Site/GetPumpManufacturer",
  getProvisionTank: "/ProvisionDevice/GetProvisionTank",
  getDecviceStatus: "/Device/GetDecviceStatus",
  addProvisionDevice: "/ProvisionDevice/AddProvisionDevice",
  getDevices: "/ProvisionDevice/GetDevices",
  getToken: "/Account/AuthToken",
  getRefreshToken: "/Account/AuthRefreshToken",
  getUser: "/Groups/GetUsersByGroupId",
  getDevicePowerType: "/Site/GetPowerSource",
};

export default ApiConstant;